import { AsYouType } from 'libphonenumber-js';

export default function format(phoneNumber) {
  if (!phoneNumber) {
    return '';
  }

  if (phoneNumber === '+46') {
    return '';
  }

  if (phoneNumber.startsWith('+46')) {
    // eslint-disable-next-line
    const formatter = new AsYouType('SE');
    return formatter.input(phoneNumber.replace(/^\+46(.+)/g, '0$1'));
  }

  // eslint-disable-next-line
  return new AsYouType().input(phoneNumber);
}

